/**
 * App 内活动 WebView 路由：`/activity-webview?url=<编码后的活动 H5 完整 URL>&user_code=...`
 * 外站深链使用 host `activity-webview` + 相同 query，与端上约定一致即可。
 */
export const ANDROID_QIPAO_PACKAGE = 'ai.yingsai.packageqipao';
export const ACTIVITY_WEBVIEW_HOST = 'activity-webview';

/**
 * @param {string} activityH5FullUrl 当前活动页完整地址（未编码）
 * @param {string} [userCode]
 * @returns {string} query 串，`url` 为一次 encodeURIComponent 后的值
 */
export function buildActivityWebviewQuery(activityH5FullUrl, userCode) {
  const parts = [`url=${encodeURIComponent(activityH5FullUrl)}`];
  if (userCode) {
    parts.push(`user_code=${encodeURIComponent(userCode)}`);
  }
  return parts.join('&');
}

/**
 * @param {string} activityH5FullUrl
 * @param {string} [userCode]
 * @returns {string}
 */
export function buildQipaoActivityWebviewScheme(activityH5FullUrl, userCode) {
  return `qipao://${ACTIVITY_WEBVIEW_HOST}?${buildActivityWebviewQuery(activityH5FullUrl, userCode)}`;
}

/**
 * @param {string} activityH5FullUrl
 * @param {string} [userCode]
 * @param {string} pkg
 * @param {string} fallbackUrl
 * @returns {string}
 */
export function buildAndroidIntentActivityWebview(activityH5FullUrl, userCode, pkg, fallbackUrl) {
  const qs = buildActivityWebviewQuery(activityH5FullUrl, userCode);
  return `intent://${ACTIVITY_WEBVIEW_HOST}?${qs}#Intent;scheme=qipao;package=${pkg};S.url=${encodeURIComponent(
    activityH5FullUrl
  )};${userCode ? `S.user_code=${encodeURIComponent(userCode)};` : ''}S.browser_fallback_url=${encodeURIComponent(
    fallbackUrl
  )};end`;
}
